<template>
  <v-select :label="label" v-model="lazyValue" @change="onValueChanged" prepend-inner-icon="mdi-plus" @click:prepend-inner="editFlag=true" :items="items" item-text="name" item-value="code" dense hide-details outlined>
    <template v-slot:item="{item}">
      <v-row no-gutters align="center">
        <v-col cols="12" class="caption primary--text">{{item.name}}</v-col>
        <v-col v-for="(cv,ci) in item.code.split(',')" :key="ci" cols="auto">
          <v-chip small :color="cv" class="rounded-0"></v-chip>
        </v-col>
      </v-row>
    </template>
    <template v-slot:append-outer>
      <v-dialog v-model="editFlag" max-width="350">
        <v-card>
          <v-card-title>自定义颜色组
            <v-spacer />
            <v-icon @click="editFlag=false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <color-group-editor v-if="editFlag" @change="onValueChanged"></color-group-editor>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
  </v-select>
</template>
<script>
import ColorGroupEditor from './ColorGroupEditor.vue';
export default {
  props: ['value', 'label', 'items'],
  data () {
    return {
      lazyValue: this.value,
      editFlag: false
    }
  },
  mounted () {
    this.$el.getElementsByClassName('v-input__append-outer')[0].setAttribute('style', 'margin-left: 0 !important');
  },
  model: { event: 'change' },
  components: { ColorGroupEditor },
  methods: {
    onValueChanged (e) {
      this.$emit('change', e);
      if (this.editFlag) this.editFlag = false;
    }
  }
}
</script>